<script lang="ts">
import vtkMouseCameraTrackballZoomToMouseManipulator from '@kitware/vtk.js/Interaction/Manipulators/MouseCameraTrackballZoomToMouseManipulator';
import { computed, defineComponent, h } from 'vue';

import { ViewportToolMode } from '@/src/store/contours/types/tool-modes-type';
import { useViewportStateStore } from '@/src/store/contours/viewport-state-store';

import MouseManipulatorTool from './MouseManipulatorTool.vue';

export default defineComponent({
  props: {
    viewId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const viewportStateStore = useViewportStateStore();
    const toolOptions = computed(() => {
      const options = [] as any[];
      options.push({ button: 3, flipDirection: true });
      options.push({ button: 1, control: true, flipDirection: true });
      if (
        viewportStateStore.getToolMode(props.viewId) === ViewportToolMode.Zoom
      ) {
        options.push({ button: 1, flipDirection: true });
      }
      return options;
    });
    return () =>
      h(MouseManipulatorTool, {
        ...props,
        name: 'ZoomTool',
        manipulatorClass: vtkMouseCameraTrackballZoomToMouseManipulator,
        options: toolOptions.value,
      });
  },
});
</script>
